const translations = {
  "en": {
    "Hot News": "Hot News",
    "Recommend": "Recommend",
    "source:": "source:"
  },
  "zh-tw": {
    "Hot News": "熱門新聞",
    "Recommend": "推薦",
    "source:": "來源："
  }
};

export default translations;
